<template>
  <div>
    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>

    <div v-if="!loading">
      <div v-if="role" class="flex flex-col">
        <div class="card">
          <card-header :title="'Rol #' + role.id">
            <template #actions>
              <router-link
                v-if="hasPermission('edit_roles')"
                :to="{ name: 'rolesEditForm', params: { id: role.id } }"
              >
                <edit-button />
              </router-link>

              <delete-button
                v-if="hasPermission('delete_roles')"
                @click="openDeleteModal()"
              />
            </template>
          </card-header>

          <div class="detail-grid">
            <detail-field label="Nombre" :value="role.name" />
            <detail-field label="Fecha de creación" :value="formatDatetime(role.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(role.updated_at)" />
          </div>

          <section-header title="Permisos" />
          <p
            class="detail-value"
            v-for="permission in role.permissions"
            :key="permission.id"
          >
            - {{ permission.display_name }}
          </p>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Role Detail",

  data() {
    return {
      role: null,
      loading: false,
      loadingDelete: false,
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setSelectedTab", "roles");

    this.loadRole();
  },

  methods: {
    formatDatetime,

    async loadRole() {
      this.loading = true;

      try {
        this.role = await api.roles.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: this.role.name,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "roles" });
      }

      this.loading = false;
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.roles.delete(this.role.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.$router.push({ name: "rolesIndex" });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>